import type {AreaEffect} from "@/encounter/model/AreaEffect.ts";
import type Combatant from "@/encounter/model/Combatant.ts";
import {effectsOnLevel} from "./AreaEffectLevel.ts";
import {pointInAreaEffect} from "./AreaEffectContainment.ts";

export type AreaEffectMark = {id: string; number: number; color: string; name: string};

/** Number all effects on this level so toggling highlight/visibility does not renumber them. */
export function numberedAreaEffects(effects: AreaEffect[], combatants: Combatant[], levelId: string) {
    return effectsOnLevel(effects, combatants, levelId)
        .sort((a, b) => a.id.localeCompare(b.id))
        .map((effect, index) => ({effect, number: index + 1}));
}

export function tokenAreaEffectMarks(
    effects: ReturnType<typeof numberedAreaEffects>, combatants: Combatant[], combatant: Combatant,
): AreaEffectMark[] {
    return effects.filter(({effect}) => effect.highlighted && !effect.hidden
        && pointInAreaEffect(effect, combatant.position, combatants.find(source => source.id === effect.combatantId)))
        .map(({effect, number}) => ({id: effect.id, number, color: effect.color, name: effect.name || "Flächeneffekt"}));
}

/** Bound the row width; the final badge summarizes additional effects. */
export function visibleAreaEffectMarks(marks: AreaEffectMark[]) {
    return marks.length <= 6 ? marks.map(mark => ({...mark, label: String(mark.number)}))
        : [...marks.slice(0, 5).map(mark => ({...mark, label: String(mark.number)})),
            {id: "overflow", number: 0, label: `+${marks.length - 5}`, color: "#cbd5e1",
                name: marks.slice(5).map(mark => mark.name).join(", ")}];
}
